// APP
export const SET_ALERT = "SET_ALERT";
export const SET_ALERT_VISIBILITY = "SET_ALERT_VISIBILITY";

// LANGUAGE
export const FETCH_LANGUAGES = "FETCH_LANGUAGES";
export const FETCH_TRANSLATION = "FETCH_TRANSLATION";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const VALIDATE_LANGUAGE_HASH = "VALIDATE_LANGUAGE_HASH";